import type { GuidedQuestion } from "@/features/blueprints/guided/guidedTypes";

export const guidedQuestions: GuidedQuestion[] = [
  {
    id: "q1",
    title: "What do you want to build?",
    helper:
      "Describe the app idea in plain English. Keep it focused on the first useful version.",
    inputType: "text",
    allowUnsure: false,
  },
  {
    id: "q2",
    title: "Who is this for, and what problem should it solve?",
    helper:
      "Who will use it, and what are they currently doing manually, slowly, or with too much effort?",
    inputType: "text",
    allowUnsure: true,
    chips: [
      "Customers or clients",
      "Members",
      "Business owners",
      "Internal team",
      "Service providers",
      "Students",
      "Creators",
      "Admin users",
      "Event organisers",
      "Coaches/consultants",
    ],
  },
  {
    id: "q3",
    title: "What should users be able to do in the first version?",
    helper: "Choose the most important actions only. Keep this first version simple.",
    inputType: "chips",
    allowUnsure: true,
    chips: [
      "Create records",
      "Edit records",
      "Delete records",
      "Search or filter",
      "Submit a form",
      "Make a booking",
      "View a dashboard",
      "Upload information",
      "Generate an AI output",
      "Send a notification",
      "Manage users",
      "Track progress",
      "View reports",
      "Save notes",
      "Mark statuses",
    ],
    optionalTextLabel: "Add any other important action.",
  },
  {
    id: "q4",
    title: "What screens or pages do you imagine?",
    helper:
      "Pick what feels obvious. If unsure, choose I don't know and we'll infer a simple layout.",
    inputType: "chips",
    allowUnsure: true,
    chips: [
      "Home page",
      "Dashboard",
      "Form page",
      "List/table page",
      "Detail page",
      "Results page",
      "Admin page",
      "Login/signup",
      "Confirmation page",
      "Settings page",
      "Search page",
      "Profile page",
      "Content/library page",
    ],
  },
  {
    id: "q5",
    title: "What should this first version NOT include?",
    helper:
      "This keeps your first version focused and stops the builder from adding unnecessary complexity.",
    inputType: "chips",
    allowUnsure: true,
    chips: [
      "No payments yet",
      "No mobile app",
      "No complex admin system",
      "No advanced analytics",
      "No third-party integrations",
      "No AI features yet",
      "No multi-language support",
      "No complicated user roles",
      "No custom branding yet",
      "No email sending yet",
      "No file uploads yet",
      "Keep it simple",
      "Focus only on the main flow",
    ],
    optionalTextLabel: "Anything else to leave out?",
  },
];

export function getGuidedQuestionIndex(questionId: string): number {
  return guidedQuestions.findIndex((question) => question.id === questionId);
}
